<template>
  <v-card>
    <v-card-title>
      <h3 class="gray--text text--lighten-1">Filtros</h3>
    </v-card-title>
    <v-card-text>
      <v-form @submit.prevent="submitFilters">
        <v-row dense>
          <v-col>
            <v-radio-group
              v-model="futureServiceFilterType" dense row class="my-0">
              <v-radio label="Mostrar Todos" value="all" />

              <v-radio label="Aguardando autorização" value="status_waiting_authorization"/>
              <v-radio label="Aguardando execução" value="status_waiting_execution" />
              <v-radio label="Aguardando execução (Medico)" value="status_waiting_doctor" />
              <v-radio label="Executando" value="status_executing" />
              <v-radio label="Finalizado" value="status_finished" />
              <v-radio label="Executando por médico" value="status_executing_by_doctor" />
              <v-radio label="Cancelado" value="status_canceled" />
              <v-radio label="Solicitação vencida" value="status_medical_request_expired" />

              <v-radio label="Apenas Procedimentos Futuros" value="future_only" />
              <v-radio label="Apenas Procedimentos do Atendimento" value="attendance_only" />
            </v-radio-group>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "MedicalRequestsFilter",
  data() {
    return {
      futureServiceFilterType: "all",
    };
  },
  watch: {
    futureServiceFilterType() {
      this.submitFilters();
    },
  },
  methods: {
    submitFilters() {
      const filters = {
        futureServiceFilterType: this.futureServiceFilterType,
      };

      this.$emit("submit", filters);
    },
  },
};
</script>

<style scoped></style>
